module.exports = __webpack_public_path__ + "img/fyy-pause.1c57e1c5.png";